/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConnectResponse,
  DisconnectResponse,
  IntegrationStatusListRequest,
  IntegrationStatusListResponse,
  IntegrationStatusResponse,
  MapString,
  SettingsResponse,
  SettingsUpsertRequest,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "microsoft-authentication";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Initiates OAuth authorization flow to connect an account to Microsoft
   *
   * @name ConnectAnAccountToMicrosoft
   * @request POST:/v1/tenant/{tenantId}/credential-ref/{credentialRef}/connect
   * @deprecated
   * @secure
   */
  connectAnAccountToMicrosoft = (
    tenantId: string,
    credentialRef: string,
    query: {
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ConnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential-ref/${credentialRef}/connect`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for connectAnAccountToMicrosoft */
  connectAnAccountToMicrosoftPathGetter = (
    tenantId: string,
    credentialRef: string,
    query: {
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/credential-ref/${credentialRef}/connect`, query);

  /**
   * @description Disconnects an account from Microsoft if is connected
   *
   * @name DisconnectAnAccountFromMicrosoft
   * @request POST:/v1/tenant/{tenantId}/credential-ref/{credentialRef}/disconnect
   * @secure
   */
  disconnectAnAccountFromMicrosoft = (tenantId: string, credentialRef: string, params: RequestParams = {}) =>
    this.request<
      DisconnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential-ref/${credentialRef}/disconnect`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for disconnectAnAccountFromMicrosoft */
  disconnectAnAccountFromMicrosoftPathGetter = (tenantId: string, credentialRef: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/credential-ref/${credentialRef}/disconnect`);

  /**
   * @description Returns scopes for the given accountId of the given tenant if the permission for the given scope was granted.
   *
   * @name Scopes
   * @request GET:/v1/tenant/{tenantId}/credential-ref/{credentialRef}/status
   * @secure
   */
  scopes = (tenantId: string, credentialRef: string, params: RequestParams = {}) =>
    this.request<
      IntegrationStatusResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential-ref/${credentialRef}/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for scopes */
  scopesPathGetter = (tenantId: string, credentialRef: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/credential-ref/${credentialRef}/status`);

  /**
   * @description Returns scopes for accountIds of the given tenant if the permission for the given scope was granted.
   *
   * @name Scopes2
   * @request POST:/v1/tenant/{tenantId}/account/status
   * @originalName scopes
   * @duplicate
   * @secure
   */
  scopes2 = (tenantId: string, data: IntegrationStatusListRequest, params: RequestParams = {}) =>
    this.request<
      IntegrationStatusListResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/account/status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for scopes2 */
  scopes2PathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/account/status`);

  /**
   * @description Disconnects a secondary calendar from Microsoft if is connected
   *
   * @name DisconnectSecondaryCalendarFromMicrosoft
   * @request POST:/v1/tenant/{tenantId}/secondary-calendars/disconnect
   * @secure
   */
  disconnectSecondaryCalendarFromMicrosoft = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      user_id: string;
      /** @minLength 1 */
      account_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      DisconnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/secondary-calendars/disconnect`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for disconnectSecondaryCalendarFromMicrosoft */
  disconnectSecondaryCalendarFromMicrosoftPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      user_id: string;
      /** @minLength 1 */
      account_id: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/secondary-calendars/disconnect`, query);

  /**
   * @description Retrieves tenant settings for Microsoft integration
   *
   * @name GetTenantSettings
   * @request GET:/v1/tenant/{tenantId}/settings
   * @secure
   */
  getTenantSettings = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SettingsResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTenantSettings */
  getTenantSettingsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/settings`);

  /**
   * @description Creates or updates tenant settings for Microsoft integration
   *
   * @name UpsertTenantSettings
   * @request PUT:/v1/tenant/{tenantId}/settings
   * @secure
   */
  upsertTenantSettings = (tenantId: string, data: SettingsUpsertRequest, params: RequestParams = {}) =>
    this.request<
      SettingsResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertTenantSettings */
  upsertTenantSettingsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/settings`);

  /**
   * No description
   *
   * @name ReceivesCallbacksFromMicrosoftOnAuthorizationRequestCompletion
   * @request GET:/v1/public/oauth/callback
   */
  receivesCallbacksFromMicrosoftOnAuthorizationRequestCompletion = (
    query: {
      /**
       * Authorization code to be used to get an access token
       * @minLength 1
       */
      code: string;
      /**
       * OAuth state with flow metadata
       * @minLength 1
       */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for receivesCallbacksFromMicrosoftOnAuthorizationRequestCompletion */
  receivesCallbacksFromMicrosoftOnAuthorizationRequestCompletionPathGetter = (query: {
    /**
     * Authorization code to be used to get an access token
     * @minLength 1
     */
    code: string;
    /**
     * OAuth state with flow metadata
     * @minLength 1
     */
    state: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);
}
